// @flow

import ApiError from 'PMT/entities/ApiError'
import I18n from 'PMT/i18n/I18n'
import ReduceStore from 'PMT/flux/ReduceStore'

import ActionTypes from 'constants/ActionTypes'
import Events from 'constants/Events'

class ApiConsumersStore extends ReduceStore {

  getInitialState() {
    return {
      data: null,
      apiError: null,
      isFetching: false,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      data: {},
      isFetching: false,
    }
  }

  getState() {
    return this._state
  }

  getOptions() {
    if (!_.isNull(this._state.data)) {
      const sourcesList = this._state.data.apiConsumers.map(({ id, name }) => {
        return {
          label: name,
          value: id,
        }
      })
      sourcesList.push({
        label: I18n.tr('order.statistics.other'),
        value: 0,
      })

      return sourcesList
    }

    return null
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState()

      case ActionTypes.GET_API_CONSUMERS:
        nextState.data = null
        nextState.isFetching = true
        nextState.apiError = null
      return nextState

      case ActionTypes.GET_API_CONSUMERS_SUCCESS:
        nextState.data = action.data
        nextState.isFetching = false
        nextState.apiError = null
        return nextState

      case ActionTypes.GET_API_CONSUMERS_FAILURE:
        nextState.data = null
        nextState.isFetching = false
        nextState.apiError = action.apiError
        return nextState

      default:
        return nextState
    }
  }
}

export default new ApiConsumersStore()



// WEBPACK FOOTER //
// ./scripts/stores/ApiConsumersStore.js